import { Component, Input } from '@angular/core';

import { ReadingIntentionsKey } from '®shared/annotations';
import { CourseReserveFilterStatus } from '®shared/reading-list/quick-filters/course-reserve-status-filter-and-label';
import { DigitisationFilterStatus } from '®shared/reading-list/quick-filters/digitisation-status-filter-and-label';

@Component({
  selector: 'rl-quick-filter-label',
  templateUrl: './quick-filter-label.component.html',
})
export class QuickFilterLabelComponent {
  @Input() quickFilterId: any;
  @Input() quickFilterType: string;
  @Input() quickFilterValue: any;
  ReadingIntentionsKey = ReadingIntentionsKey;
  DigitisationFilterStatus = DigitisationFilterStatus;
  CourseReserveFilterStatus = CourseReserveFilterStatus;
}
